import { type Rarity, rarityLabel } from '../models/types';
import { rarityColors } from '../theme';

export function RarityBadge({ rarity, compact = false }: { rarity: Rarity; compact?: boolean }) {
  return (
    <span className={`rarity-badge${compact ? ' compact' : ''}`} style={{ background: rarityColors[rarity] }}>
      {rarityLabel(rarity).toUpperCase()}
    </span>
  );
}
